module.exports = __webpack_public_path__ + "static/media/Zahlzerlegungshaeuschen.cb5c7b67.svg";